// src/features/landing/presentation/components/CompanyContactSection.jsx
import React from "react";
import "./CompanyContactSection.css";

export function CompanyContactSection() {
    const contactInfo = [
        {
            id: 1,
            icon: "/images/logo/blog.png",
            isImage: true,
            label: "블로그",
            value: "rising_brokers",
            link: "https://m.blog.naver.com/rising_brokers/224072104964",
        },
        {
            id: 2,
            icon: "/images/logo/insta.jpeg",
            isImage: true,
            label: "인스타그램",
            value: "@risingbrokers_official",
            link: "https://www.instagram.com/risingbrokers_official?igsh=ajB5emx4aDg4cXBi",
        },
        {
            id: 3,
            icon: "/images/logo/kakao.png",
            isImage: true,
            label: "카카오톡",
            value: "라이징브로커즈",
            link: "http://pf.kakao.com/_Tdzxen",
        },
        {
            id: 4,
            icon: "📞",
            label: "전화",
            value: "02-858-2014",
        },
        {
            id: 5,
            icon: "✉️",
            label: "이메일",
            value: "risingbrokers1@gmail.com",
        }
    ];

    const handleLinkClick = (link) => {
        if (link) {
            const newWindow = window.open(link, "_blank");
            if (newWindow) {
                newWindow.opener = null;
            }
        }
    };

    return (
        <section className="company-contact-section">
            <div className="contact-container">
                <div className="section-header">
                    <h2 className="section-title">
                        다양한 <span className="title-highlight">채널 운영</span>
                    </h2>
                    <p className="section-description">
                        라이징브로커즈는 항상 열려있습니다. 편하신 방법으로 연락주세요.
                    </p>
                </div>

                <div className="contact-info-list">
                    {contactInfo.map((info) => (
                        <div
                            key={info.id}
                            className={`contact-info-item ${info.link ? 'clickable' : ''}`}
                            onClick={() => info.link && handleLinkClick(info.link)}
                        >
                            {info.isImage ? (
                                <img src={info.icon} alt={info.label} className="info-icon" />
                            ) : (
                                <span className="info-icon">{info.icon}</span>
                            )}
                            <span className="info-label">{info.label}</span>
                            <span className="info-value">{info.value}</span>
                            {info.link && <span className="link-arrow">→</span>}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
